import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { jiraUserApiURL, baseAPI } from 'src/app/services/apiRoutes';
import { Observable } from 'rxjs';
 
@Injectable()
export class JiraUserService {
  constructor(public http: HttpClient) {}

  getJiraUsers(query: string, upn: boolean = false) {
    return this.http.get(jiraUserApiURL + '?query=' + query + '&upn=' + upn).toPromise();
  }

  createUser(userId: string, target, groups) : Observable<any> {
    return this.http.post(baseAPI + '/user/' + target + '/activate?uid=' + userId, groups);
  }

  getUserGroupMembership() {
    return this.http.get(baseAPI + '/user/group/membership').toPromise();
  }

}
